import { AssetSchema } from '@innovyze/lib_asset_schema';
import {
	assetSchemaSelectorByType,
	getAssetSchemaAction,
} from '@innovyze/lib_asset_schema_store';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useNoConditionData = (assetType: string): boolean => {
	const dispatch = useDispatch();

	useEffect(() => {
		if (assetType) {
			dispatch(getAssetSchemaAction({ assetType }));
		}
	}, [assetType, dispatch]);

	const assetSchema: AssetSchema | undefined = useSelector(state => {
		if (assetType) {
			return assetSchemaSelectorByType(state, assetType);
		}
	});

	const hasInspections = assetSchema?.hasCapability('Inspections') ?? false;

	const noConditionData = !hasInspections;

	return noConditionData;
};
